import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs';
import {LocationStrategy} from '@angular/common';
import {Self} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {LoggerService} from "../logger.service";
import {ConfigResponse, DataRequestOptions} from "../../models";

export abstract class BasicDataService {

    protected POLL_SERVICE_URL: string = '/hbsPoll/rest/';
    protected hasBaseUrl: boolean;

    constructor(@Self() protected http: HttpClient,
                protected locationStrategy: LocationStrategy,
                protected logger: LoggerService) {
        this.hasBaseUrl = this.locationStrategy.getBaseHref() === '/';
        this.logger.log('BasicDataService: http:', http, 'hasBaseUrl:', this.hasBaseUrl, this.locationStrategy.getBaseHref());
    }

    public isBaseUrl(): boolean {
        return this.hasBaseUrl;
    }

    public getConfig(forSignedUser: boolean): Observable<ConfigResponse> {
        this.logger.log('BasicDataService: getConfig', 'locationStrategy:', this.locationStrategy.getBaseHref());

        const url = this.POLL_SERVICE_URL + (forSignedUser ? 'signed/' : 'anonymous/') + 'config.json';
        return this.http.get<ConfigResponse>(url);
    }

    protected dataRequestOptionsToHeaders(options: DataRequestOptions): HttpHeaders {

        let headers = new HttpHeaders();
        if (options && options.anonymous && options.token) {
            headers = headers.append('XHBS_POLL_TOKEN', options.token);
        }

        // testing only: headers = headers.append('HBS_PERSON_ID', '772034');

        // if (options.lockOnce) {
        //     // TODO: adjust when LOCK_ONCE is needed
        //     headers.append('LOCK_ONCE', options.lockOnce);
        // }
        headers = headers.append('LOCK_ONCE', '1');

        // console.log('dataRequestOptionsToHeaders:', 'options:', options, 'headers:', headers);

        return headers;
    }

}
